import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Badge from '@/components/base/Badge';

export default function ReviewPanel({ reference }: { reference: string }) {
  const { t } = useTranslation();

  return (
    <div className="lb-glass rounded-lg p-6 text-center md:p-8">
      <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-600">
        <i className="ri-hourglass-2-line text-2xl leading-none" aria-hidden="true" />
      </span>

      <div className="flex justify-center">
        <Badge variant="warning" icon="ri-time-line">
          {t('status.under_review')}
        </Badge>
      </div>

      <h1 className="mt-4 text-xl font-bold text-foreground-950">{t('auth.register.reviewTitle')}</h1>
      <p className="mx-auto mt-2 max-w-lg text-sm leading-relaxed text-foreground-600">
        {t('auth.register.reviewText')}
      </p>

      <div className="mx-auto mt-5 w-full max-w-sm rounded-lg bg-background-100 px-4 py-3 text-start">
        <p className="text-xs text-foreground-500">{t('common.demoData')}</p>
        <p className="lb-ltr-field mt-1 text-sm font-semibold text-foreground-900">{reference}</p>
      </div>

      <p className="mx-auto mt-5 max-w-lg text-sm text-foreground-600">
        {t('auth.register.reviewAccepted')}
      </p>
      <p className="mx-auto mt-3 max-w-lg text-xs text-foreground-500">{t('auth.register.demoNotice')}</p>

      <div className="mt-6">
        <Link
          to="/login"
          className="inline-flex h-11 items-center justify-center rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {t('auth.register.reviewToLogin')}
        </Link>
      </div>
    </div>
  );
}